import {
  EPdfBlockType,
  type IPdfBlock,
} from '@mahawi/eshop-common/dist/src/types';
import React from 'react';

export default function LegalBlock({
  block,
}: {
  block: IPdfBlock;
}): React.JSX.Element | null {
  if (block.type === EPdfBlockType.LIST) {
    return (
      <ul>
        {(block.items ?? []).map(
          (item: string, index: number): React.JSX.Element => (
            <li key={`item-${index}`}>
              <p>{item}</p>
            </li>
          ),
        )}
      </ul>
    );
  }

  if (block.type === EPdfBlockType.PARAGRAPH) {
    return <p>{block.text}</p>;
  }

  return null;
}
